import Resume from '../assets/AaronSternResumeV2.pdf';

const files = { Resume };

export default files;
